"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconAutoCompleteQuestionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_select_1 = require("react-select");
var React = require("react");
var journey_model_1 = require("@athena-portal/journey-model");
var OptimizedMenuList_1 = require("./OptimizedMenuList");
var OptimizedOption_1 = require("./OptimizedOption");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var FalconAutoCompleteQuestionWidget = /** @class */ (function (_super) {
    __extends(FalconAutoCompleteQuestionWidget, _super);
    function FalconAutoCompleteQuestionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = React.createRef();
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        _this.handleOnBlurEvent = _this.handleOnBlurEvent.bind(_this);
        return _this;
    }
    FalconAutoCompleteQuestionWidget.prototype.handleOnBlurEvent = function (e) {
        var inputValue = this.inputRef.current.state.value;
        if (!inputValue) {
            return;
        }
        var parsedObj = {
            target: {
                id: inputValue.value,
                value: inputValue.value
            }
        };
        _super.prototype.handleOnBlurEvent.call(this, parsedObj);
    };
    FalconAutoCompleteQuestionWidget.prototype.renderInputField = function () {
        var _this = this;
        var values = this.state.lookupValues && this.state.lookupValues.map(function (lookupItem, idx) { return ({
            label: lookupItem.value,
            value: lookupItem.id
        }); });
        var selectedOption = values && values.filter(function (_a) {
            var value = _a.value;
            return (value === _this.bindFromField(_this.props.question.interactionField));
        });
        var filterOption = function (candidate, input) {
            return candidate.data.__isNew__ || candidate.label.toLocaleLowerCase().includes(input.toLocaleLowerCase());
        };
        return ((0, jsx_runtime_1.jsx)(react_select_1.default, { ref: this.inputRef, className: "autocomplete ".concat(this.getSetting("cssClass", ""), " ").concat(this.getInputValidationClass()), classNamePrefix: "autocomplete", menuPortalTarget: document.body, 
            // @ts-ignore
            helpTextRow1: this.getSetting("helpTextRow1", null), helpTextRow2: this.getSetting("helpTextRow2", null), components: { MenuList: OptimizedMenuList_1.default, Option: OptimizedOption_1.default }, onChange: function (e) { return _this.handleOnChangeEvent(e); }, onBlur: function (e) { return _this.handleOnBlurEvent(e); }, value: selectedOption && selectedOption[0], options: values, filterOption: filterOption, disabled: this.isReadOnly(), placeholder: this.props.question.placeHolder ? this.props.question.placeHolder : "Please select...", id: this.props.question.name }));
    };
    FalconAutoCompleteQuestionWidget.prototype.handleOnChangeEvent = function (e) {
        this.props.onStateChange(this.props.question.interactionField, e.value);
        this.validateInternal(e.value);
        this.changelogRecorder.recordQuestion("change", this.props);
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], FalconAutoCompleteQuestionWidget.prototype, "changelogRecorder", void 0);
    FalconAutoCompleteQuestionWidget = __decorate([
        (0, journey_model_1.event)(journey_model_1.Event.onChange),
        (0, journey_model_1.settings)([
            { name: "cssClass", type: journey_model_1.TypeDescriptions.CssClass },
            { name: "helpTextRow1", type: journey_model_1.TypeDescriptions.String },
            { name: "helpTextRow2", type: journey_model_1.TypeDescriptions.String },
        ]),
        __metadata("design:paramtypes", [Object])
    ], FalconAutoCompleteQuestionWidget);
    return FalconAutoCompleteQuestionWidget;
}(plugin_journey_1.SelectQuestionWidgetBase));
exports.FalconAutoCompleteQuestionWidget = FalconAutoCompleteQuestionWidget;
//# sourceMappingURL=FalconAutoCompleteQuestionWidget.js.map